export function affinityToStem(affinity: string): string {
  // affinity stems are just the base string of the affinity, so we need to remove the extra affinity markers to get the stem
  // examples where the stem is BIG:
  // STEM Affinity code (BIG)
  // STEM_X affinity code, where X is any combination of letters and numbers (BIG_123)
  // STEMBR affinity code(BIGBR)
  // STEMP affinity code(BIGP)

  // start by removing anything after underscore, then check if the last digit is P or BR, and remove those too
  const stem = affinity.split('_')[0];
  if (stem.endsWith('P')) {
    return stem.slice(0, stem.lastIndexOf('P'));
  }
  if (stem.endsWith('BR')) {
    return stem.slice(0, stem.lastIndexOf('BR'));
  }
  return stem;
}
